
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { COMPOSITION_COLUMNS, COMPOSITION_COLUMNS_NO, INGREDIENT_COLUMN_NO, CREATE_RECIPE_COLUMNS_NO, MULTI_COMPONENT, FRAGRANCE_COLUMNS, FRAGRANCE_REGIONAL_COLUMNS2, FRAGRANCE_REGIONAL_COLUMNS3, FRAGRANCE_EXCEL_COLUMNS, PROJECT_COLUMNS, INGHEADERINFO, SUBSTANCE_DETAILS, SUBSTANCE_DETAILS_IN_EDIT_ING } from 'src/app/common/models/tableColumns';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormBuilder, Validators, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ViewRecipeService } from './view-recipe.service';
import * as $ from 'jquery';
import * as _ from 'lodash';
import { AssessRequestRaService } from 'src/app/assess-request-ra/assess-request-ra.service';
import { AssessmentRequestService } from 'src/app/assess-requests/assess-requests.service';
import { DatePipe } from '@angular/common';
import { SirDetails } from 'src/app/common/models/GroupDataModel';
import { ActivatedRoute } from '@angular/router';
import { RecipeWorklistService } from '../../non-plm-recipe/recipe-worklist/recipe-worklist.service';

interface AutoCompleteCompleteEvent {
  originalEvent: Event;
  query: string;
}
@Component({
  selector: 'app-view-recipe',
  templateUrl: './view-recipe.component.html',
  styleUrls: ['./view-recipe.component.scss']
})

export class ViewRecipeComponent implements OnInit {
  requestDisplayID: string | null = null;

  items: any[] = [];
  star = 'fa fa-fw fa-search';
  readOnlyValue: any;
  todayDate;
  defaultMaxDate;
  defaultEndDate;
  defaultStartDate;
  defaultStartDateRcp;
  defaultMinDate;
  value: any;
  invalidCalc = false;
  calculatedINGQty: any;
  invalidTotalINGCalc = true;
  invalidTotalSIRCalc = true;
  calculatedSIRQty: any;
  OneStarAPIResponse: any = [];
  uniqLocalIngID: any = [];
  ingredientListData: any = [];
  popupNotValidated = false;
  segregatecompositionData = [];
  tempCompositionData = [];
  compositionDetailsColumns = [];
  editIngTable1Cols = [];
  editIngTable1Data = [{
    ingID: null,
    ingDescription: null,
    ingQuantity: null,
    oldingID: null,
    isTemporaryIngredient: null
  }];
  uploadDialog = false;
  showConfirmDelete = false;
  filteredvalidityArea = [];
  // validityarray = {
  //   validity: '',
  //   validityDescription: '',
  //   validityAreacode: ''
  // };
  validityAreavals = [];
  validityAreaVal: any;
  recipeValidated: any;
  editIngredientDialog = false;
  addIngredient = false;
  uploadedFiles: any[] = [];
  loadingmappinglistMessage = '';
  UploadData: any = [];
  buttonSelection = false;
  editIngSelection: any = '';
  substanceListOfEditIng: any[] = [];
  searchIdentifierValue = null;
  sirSearchResult = [];
  disablePureCode = false;
  sirDetails = Array<SirDetails>();
  sirObjSelectedIndex = null;
  showPuremsg = false;
  totalSirPercent = 0.0;
  groupedChemicals: any = [];
  selectedChemical: string;
  substanceOptions: any[] = [];
  selectedSubstance: any;
  recipeDescription = '';
  recipeComment = '';
  recipeId = '';
  recipeVersion = '';
  showRecipeSavedDialog = false;
  cancelClicked = false;

  // Fields For Formulation Details
  tfcDetailsfromPlm: any;
  filteredDataUpd: any[] = [];
  groupsData: any = '';
  loading = true;
  updNameDataApi = '';
  updName: any;
  selectedFC: any;
  selectedType: any;
  selectedClass: any;
  selectedSubClass: any;
  CatNewData: any = [];
  typeNewData: any = [];
  classNewData: any = [];
  SubclassNewData: any = [];
  filteredDataCat: any[] = [];
  filteredDataType: any[] = [];
  filteredDataClass: any[] = [];
  filteredDataSubclass: any[] = [];
  isFormulationCategory = true;
  isFormulationType = true;
  isFormulationClass = true;
  isFormulationSubClass = true;

  isButtonDisabled: true;
  isRecipeDescriptionDisabled: true;
  isRecipeSourceDisabled: true;
  isUPDDisabled: true;
  isRecipeCommentDisabled: true;
  isPrepartionMethodDisabled: true;

  prepartionMethodValues = [{ id: 1, value: 'As Sold' }, { id: 2, value: 'As Prepared' }];
  selectedPrepMethod;
  ingredientDetailsColumns = [];
  importfromPlm = false;
  importFromPLMDetail: any;
  additionalfielderror;
  activeTab = 'plm-ing-tab';
  cucaltver: any = '';
  validityarea: any = [];
  plmvalidityareaedit: any;
  onestarIngID: any = '';
  keydate: any = new Date();
  formAssess: any;
  recipeModel = {
    recipeID: '',
    recipeVer: '',
    recipeDescription: '',
    tfcList: null,
    prepMethod: [],
    recipeStatus: '',
    formulationRequestDetails: [],
    recipeComments: ''
  };
  ingResponseData: any;
  ingredientIdOrName = '';
  plmvalidityarea: any;
  plmkeydate: any;
  ingHeaderData = {
    ingID: '',
    ingDescription: '',
    ingQuantity: null
  };
  IngHeaderInfo = [];
  ingHeaderDataInformation = [];
  substanceDetailsData = [];
  substanceDetailsCols = [];
  substanceDetailsColsInEditIng = [];
  errorMessage = '';
  loadingPlmmessage: string;
  addIngredientDialogNonplm = false;
  loadingMessage: string;
  isplmDataValid = false;
  isAddSubstanceEnable = true;
  isIngValidData = false;
  viewtype = true;
  errorMessagechildIng: string;
  recipeSource: string;

  search(event: AutoCompleteCompleteEvent) {
    this.items = [...Array(10).keys()].map(item => event.query + '-' + item);
  }

  constructor(
    public matSnackBar: MatSnackBar,
    private apiService: ViewRecipeService,
    public recipeWorklistService: RecipeWorklistService,
    private http: HttpClient,
    public fb: FormBuilder,
    private datePipe: DatePipe,
    public router: Router,
    private assessRequestRa: AssessRequestRaService,
    public assessService: AssessmentRequestService,
    private route: ActivatedRoute,
  ) { }
  ngOnInit() {
    this.requestDisplayID = this.route.snapshot.paramMap.get('requestDisplayID');
    const apiurl = environment.APIFAsT + '/viewnonplmrecipe/' + this.requestDisplayID;
    this.recipeWorklistService.getData(apiurl).subscribe((response) => {
      if (response !== null) {
        const [recipeIdView, recipeVersionView] = this.requestDisplayID.split('_');
        this.recipeId = recipeIdView;
        this.recipeVersion = recipeVersionView;
        this.bindRecipeDetails(response);
      }
    });
    this.compositionDetailsColumns = CREATE_RECIPE_COLUMNS_NO;
    this.getGroupData();
    this.getvalidityArea();
    this.loading = false;
    this.updateTotalSirPercent();
    this.viewtype = true;
    // this.IngHeaderInfo = INGHEADERINFO;
    // this.substanceDetailsCols = SUBSTANCE_DETAILS;
    // this.substanceDetailsColsInEditIng = SUBSTANCE_DETAILS_IN_EDIT_ING;
    // this.calculatedSIRQty = 0;
    // this.calculatedINGQty = 0;
    // this.invalidCalc = true;
    // this.selectedPrepMethod = this.prepartionMethodValues[0];
    // this.ingredientDetailsColumns = INGREDIENT_COLUMN_NO;
    // this.todayDate = new Date();
    // this.defaultMaxDate = new Date('2099-12-31');
    // this.defaultMinDate = new Date('2000-01-01');
    // this.defaultEndDate = this.datePipe.transform(new Date('2099-12-31'), 'longDate');
    // this.defaultStartDate = this.datePipe.transform(this.todayDate, 'dd-MM-yyyy');
    // this.defaultStartDateRcp = this.datePipe.transform(this.todayDate, 'dd-MM-yyyy');

    this.isButtonDisabled = true;
    this.isRecipeDescriptionDisabled = true;
    this.isRecipeCommentDisabled = true;
    this.isRecipeSourceDisabled = true;
    this.isUPDDisabled = true;
    this.isPrepartionMethodDisabled = true;
    // this.isFormulationCategory = true;
    // this.isFormulationType = true;
    // this.isFormulationClass = true;
    // this.isFormulationSubClass = true;
  }
  qtyValidationCheck() {
    if (this.calculatedINGQty <= 99.9 && this.calculatedINGQty >= 100.02) {
      this.invalidCalc = true;
    } else {
      this.invalidCalc = false;
    }
    if (this.calculatedSIRQty <= 99.9 && this.calculatedSIRQty >= 100.02) {
      this.invalidCalc = true;
    } else {
      this.invalidCalc = false;
    }
  }

  openCompositionDetails(index) {
  }
  UploadDialog() {
    this.uploadDialog = true;
  }
  addIngredientDialog() {
    this.errorMessage = '';
    this.isImportAddEnable();
    this.totalSirPercent = 0.0;
    this.addIngredient = true;
    this.ingHeaderDataInformation = [];
    this.substanceDetailsData = [];
    this.clearAll();
    this.plmvalidityarea = this.validityarea.validityAreaCode;
    this.loadingmappinglistMessage = 'Fetching ING details';
  }

  // Code For Formulation Details
  getGroupData() {
    const apiurl = environment.APIFAsT + '/getsubstancesearchupds';
    this.apiService.getData(apiurl).subscribe((response1) => {
      this.groupsData = response1;
    });
  }
  searchUpd(event) {
    const filteredSearchupd = [];
    const query = event.query;
    for (const value of this.groupsData) {
      if (value.updName.toLowerCase().includes(query.toLowerCase())) {
        filteredSearchupd.push(value);
      }
    }
    this.filteredDataUpd = filteredSearchupd;
  }

  updSelected(event): void {
    this.updNameDataApi = event.updName;
    this.clearCategory();
    this.getGroupDataFormulationCategory(event);
    this.selectedFC = null;
  }

  searchFormulationCategory(event) {
    const filteredSearchCat = [];
    const query = event.query;
    for (const value of this.CatNewData) {
      if (value.tfcLevel1Name.toLowerCase().includes(query.toLowerCase())) {
        filteredSearchCat.push(value);
      }
    }
    this.filteredDataCat = filteredSearchCat;
  }
  SelectedFormulationCategory(val): void {
    this.clearType();
    this.getGroupDataFormulationType(val);
    this.selectedType = null;
  }

  searchFormulationType(event) {
    const filteredSearchType = [];
    const query = event.query;
    for (const value of this.typeNewData) {
      if (value.tfcLevel2Name.toLowerCase().includes(query.toLowerCase())) {
        filteredSearchType.push(value);
      }
    }
    this.filteredDataType = filteredSearchType;
  }
  selectedFormulationType(val): void {
    const data = val.tfcLevel2Name;
    this.clearClass();
    this.getGroupDataFormulationClass(val);
    this.selectedClass = null;
  }

  searchFormulationClass(event) {
    const filteredSearchClass = [];
    const query = event.query;
    for (const value of this.classNewData) {
      if (value.tfcLevel3Name.toLowerCase().includes(query.toLowerCase())) {
        filteredSearchClass.push(value);
      }
    }
    this.filteredDataClass = filteredSearchClass;
  }
  SelectedFormulationClass(val): void {
    this.clearSubClass();
    this.getGroupDataFormulationSubClass(val);
    this.selectedSubClass = '';
  }

  searchFormulationSubClass(event) {
    const filteredSearchSubclassData = [];
    const query = event.query;
    for (const value of this.SubclassNewData) {
      if (value.tfcLevel4Name.toLowerCase().includes(query.toLowerCase())) {
        filteredSearchSubclassData.push(value);
      }
    }
    this.filteredDataSubclass = filteredSearchSubclassData;
  }
  SelectedFormulationSubClass(val): void {
    const subClassValue = val.tfcLevel4Name;

  }

  getGroupDataFormulationCategory(typeValue) {
    const apiurl = environment.APIFAsT + '/upd/' + this.updNameDataApi + '/tfc/level/1/' + typeValue.updId;
    this.apiService.getData(apiurl).subscribe((response1) => {
      this.CatNewData = response1;
    }, (error) => {
      this.loading = false;
    });
  }

  getGroupDataFormulationType(event) {
    const apiurl = environment.APIFAsT + '/upd/' + this.updNameDataApi + '/tfc/level/2/' + event.tfcLevel1Id;
    this.apiService.getData(apiurl).subscribe((response1) => {
      this.typeNewData = response1;
    }, (error) => {
      this.loading = false;
    });
  }

  getGroupDataFormulationClass(val) {
    const apiurl = environment.APIFAsT + '/upd/' + this.updNameDataApi + '/tfc/level/3/' + val.tfcLevel2Id;
    this.apiService.getData(apiurl).subscribe((response1) => {
      this.classNewData = response1;
    }, (error) => {
      this.loading = false;
    });
  }

  getGroupDataFormulationSubClass(val) {
    const apiurl = environment.APIFAsT + '/upd/' + this.updNameDataApi + '/tfc/level/4/' + val.tfcLevel3Id;
    this.apiService.getData(apiurl).subscribe((response1) => {
      this.SubclassNewData = response1;
    }, (error) => {
      this.loading = false;
    });
  }

  clearUPD() {
    this.clearDropdownvalues(true, true, true, true);
  }

  clearCategory() {
    this.clearDropdownvalues(false, true, true, true);
  }
  clearType() {
    this.clearDropdownvalues(false, false, true, true);
  }
  clearClass() {
    this.clearDropdownvalues(false, false, false, true);
  }
  clearSubClass() {
    this.clearDropdownvalues(false, false, false, false);
  }
  clearDropdownvalues(category, type, fclass, subclass) {
    if (category) {
      this.selectedFC = null;
      this.filteredDataCat = [];
    }
    if (type) {
      this.selectedType = null;
      this.filteredDataType = [];
    }
    if (fclass) {
      this.selectedClass = undefined;
      this.filteredDataClass = [];
    }
    if (subclass) {
      this.selectedSubClass = undefined;
      this.filteredDataSubclass = [];
    }
    this.enableordisable(category, type, fclass, subclass, this.viewtype);
  }

  enableordisable(category, type, fclass, subclass, viewtype = false) {
    if (viewtype) {
      this.isFormulationCategory = true;
      this.isFormulationType = true;
      this.isFormulationClass = true;
      this.isFormulationSubClass = true;
    } else {
      this.isFormulationCategory = category;
      this.isFormulationType = type;
      this.isFormulationClass = fclass;
      this.isFormulationSubClass = subclass;
    }
  }

  populateImportFromPlmTfcData() {
    const tfc = {
      updId: '',
      updName: '',
      businessGroupName: '',
      formulationCategory: '',
      tfcLevel1Id: '',
      formulationType: '',
      tfcLevel2Id: '',
      formulationClass: '',
      tfcLevel3Id: '',
      formulationSubClass: '',
      tfcLevel4Id: ''
    };

    if (this.tfcDetailsfromPlm) {
      tfc.businessGroupName = this.tfcDetailsfromPlm.parentTFC.parentTFC.parentTFC.businessGroupName ? this.tfcDetailsfromPlm.parentTFC.parentTFC.parentTFC.businessGroupName : '';
      tfc.updName = this.tfcDetailsfromPlm.parentTFC.parentTFC.parentTFC.parentTFC.tfcLevel === 1 ? this.tfcDetailsfromPlm.parentTFC.parentTFC.parentTFC.parentTFC.tfcName : '';
      tfc.updId = this.tfcDetailsfromPlm.parentTFC.parentTFC.parentTFC.parentTFC.tfcLevel === 1 ? this.tfcDetailsfromPlm.parentTFC.parentTFC.parentTFC.parentTFC.tfcId : '';
      tfc.formulationCategory = this.tfcDetailsfromPlm.parentTFC.parentTFC.parentTFC.tfcLevel === 2 ? this.tfcDetailsfromPlm.parentTFC.parentTFC.parentTFC.tfcName : '';
      tfc.tfcLevel1Id = this.tfcDetailsfromPlm.parentTFC.parentTFC.parentTFC.tfcLevel === 2 ? this.tfcDetailsfromPlm.parentTFC.parentTFC.parentTFC.tfcId : '';
      tfc.formulationType = this.tfcDetailsfromPlm.parentTFC.parentTFC.tfcLevel === 3 ? this.tfcDetailsfromPlm.parentTFC.parentTFC.tfcName : '';
      tfc.tfcLevel2Id = this.tfcDetailsfromPlm.parentTFC.parentTFC.tfcLevel === 3 ? this.tfcDetailsfromPlm.parentTFC.parentTFC.tfcId : '';
      tfc.formulationClass = this.tfcDetailsfromPlm.parentTFC.tfcLevel === 4 ? this.tfcDetailsfromPlm.parentTFC.tfcName : '';
      tfc.tfcLevel3Id = this.tfcDetailsfromPlm.parentTFC.tfcLevel === 4 ? this.tfcDetailsfromPlm.parentTFC.tfcId : '';
      tfc.formulationSubClass = this.tfcDetailsfromPlm.tfcLevel === 5 ? this.tfcDetailsfromPlm.tfcName : '';
      tfc.tfcLevel4Id = this.tfcDetailsfromPlm.tfcLevel === 5 ? this.tfcDetailsfromPlm.tfcId : '';
    }
    this.updNameDataApi = tfc.businessGroupName;
    this.getGroupData();
    const bgName = (tfc.businessGroupName || '').trim().toLowerCase();
    const matchedUpd = Array.isArray(this.groupsData)
      ? this.groupsData.find(g => ((g.businessGroupName || g.updName || '').trim().toLowerCase()) === bgName) : null;
    if (matchedUpd) {
      tfc.updId = matchedUpd.updId || matchedUpd.tfcId || tfc.updId;
    }
    this.updSelected({ updId: tfc.updId, updName: tfc.businessGroupName });
    this.SelectedFormulationCategory({ tfcLevel1Id: tfc.tfcLevel1Id });
    this.selectedFormulationType({ tfcLevel2Id: tfc.tfcLevel2Id });
    this.SelectedFormulationClass({ tfcLevel3Id: tfc.tfcLevel3Id });
    this.updName = { updName: tfc.businessGroupName, updId: tfc.updId };
    this.selectedFC = { tfcLevel1Name: tfc.formulationCategory, tfcLevel1Id: tfc.tfcLevel1Id };
    this.selectedType = { tfcLevel2Name: tfc.formulationType, tfcLevel2Id: tfc.tfcLevel2Id };
    this.selectedClass = { tfcLevel3Name: tfc.formulationClass, tfcLevel3Id: tfc.tfcLevel3Id };
    this.selectedSubClass = { tfcLevel4Name: tfc.formulationSubClass, tfcLevel4Id: tfc.tfcLevel4Id };


  }
  // End of Code for formulation details

  onUpload(event, fileuploadForm) {
    this.uploadedFiles = [];
    for (const file of event.files) {
      this.uploadedFiles.push(file);
    }
    fileuploadForm.clear();
    this.loadingmappinglistMessage = 'Loading Excel Data into table';
    const fileToUpload = <File> this.uploadedFiles[0];
    const apiurl = environment.APIFAsT + '/nonPLMRecipe/recipedata/uploadfile';
    this.loading = true;
    const formData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);
    const headerdata = new HttpHeaders({
      Authorization: 'Bearer ' + localStorage.getItem('FunctionToken'),
      'X-FAST-AUTH-K': '6ee2a098-e2d6-4893-b8b4-18f01c9a67a1-6DB1487E-C741-4669-B8BB-9F34EE294EEF'
    });
    this.http.post<any>(apiurl, formData, { headers: headerdata })
      .subscribe((response) => {
        this.UploadData = response;
        // console.log(this.UploadData);
        this.loading = false;
        this.uploadDialog = false;
        const oneStarIngsInMainTable = new Set(this.segregatecompositionData.map(item => item.ingID));
        const uniqueOneStarIngsFromExcelFile = this.UploadData.filter(item => !oneStarIngsInMainTable.has(item.ingID));
        const duplicatesIngsFromExcel = this.UploadData.filter(item => oneStarIngsInMainTable.has(item.ingID));
        if (uniqueOneStarIngsFromExcelFile !== undefined && uniqueOneStarIngsFromExcelFile.length !== 0) {
          this.ingredientListData = uniqueOneStarIngsFromExcelFile.map(respElem =>
            respElem.ingPureDetails.map(pure => ({
              ingID: respElem.ingID,
              ingName: respElem.ingDescription,
              ingredientPer: respElem.ingQuantity,
              pureCode: pure.pureCode,
              subName: pure.substanceName,
              sirId: pure.substanceID,
              casNumber: pure.casNumber,
              inciName: pure.inciNumber,
              einecs: pure.einecsNumber,
              sirPercentageInIng: pure.recipeQuantity,
              sirQty: pure.pureQuantityPerItem,
              uom: pure.recipeUoM,
              errorDetails: null,
              isTemporaryIngredient: respElem.isTemporaryIngredient,
            }))
          );
        }
        console.log(this.ingredientListData);
        this.ingredientListData = this.ingredientListData.flat();
        console.log(this.ingredientListData);
        this.segregatecompositionData = this.segregatecompositionData.concat(this.ingredientListData);
        if (duplicatesIngsFromExcel.length > 0) {
          const duplicateIdsString = duplicatesIngsFromExcel.map(item => item.ingID).join(', ');
          const message = 'Ingredients ' + duplicateIdsString + ' is not added as it is already present in the composition';
          this.matSnackBar.open(message, 'close', {
            duration: 7000,
            panelClass: ['errorDialog']
          });
        }
        this.calculateingQtySIRQty();
      }, (error) => {
        this.uploadDialog = false;
        this.loading = false;
        if (error.error.message !== undefined) {
          this.matSnackBar.open(error.error.message, 'close', {
            duration: 5000,
            panelClass: ['errorDialog']
          });
        }
      });
    this.loadIngredientTable();
  }
  validateOtherDetailsforRecipe() {
    if (this.segregatecompositionData.length > 0) {
      this.segregatecompositionData.forEach(item => {
        if (item.errorDetails === 'Invalid Substance') {
          // incase if error details is having invalid substance, no other checks will be performed.

        } else {
          item.errorDetails = 'No Issues Found';
          if (isNaN(parseFloat(item.ingredientPer)) || !isFinite(item.ingredientPer)) {
            item.errorDetails = 'Invalid Ingredient %';
          }
          if (isNaN(parseFloat(item.sirPercentageInIng)) || !isFinite(item.sirPercentageInIng)) {
            item.errorDetails = 'Invalid Substance %';
          }
          if (!(isNaN(parseFloat(item.sirPercentageInIng)) || !isFinite(item.sirPercentageInIng))) {
            item.sirQty = (item.ingredientPer * item.sirPercentageInIng) / 100;
            if (isNaN(parseFloat(item.sirQty)) || !isFinite(item.sirQty)) {
              item.errorDetails = 'Invalid Substance Qty%';
            }
          }
          if (item.uom === '' || item.uom === null) {
            item.errorDetails = 'Invalid UoM';
          }
        }


      });
      this.calculateingQtySIRQty();
      if (!(this.calculatedINGQty >= 99.09 && this.calculatedINGQty <= 100.02)) {
        this.recipeValidated = 0;
      }
      if (!(this.calculatedSIRQty >= 99.09 && this.calculatedSIRQty <= 100.02)) {
        this.recipeValidated = 0;
      }

    } else {
      this.recipeValidated = 0;
    }
  }
  validateCompositionDetail() {
    this.loading = true;
    let substancestring = '';
    this.segregatecompositionData.forEach(item => {
      if (substancestring === '') {
        substancestring = item.sirId;
      } else {
        substancestring = substancestring + ', ' + item.sirId;
      }
    });

    this.loadingmappinglistMessage = 'Validating Substances';
    this.substanceOptions = [];
    const apiurl = environment.APIFAsT + '/substancelistfornonplm/' + substancestring;
    this.apiService.getData(apiurl).subscribe((response1) => {
      this.sirSearchResult = response1;
      this.segregatecompositionData.forEach(element => {
        const substanceFound = this.sirSearchResult.filter(f => f.sirId === element.sirId);
        if (substanceFound.length !== undefined) {
          if (substanceFound.length <= 0) {
            element.errorDetails = 'Invalid Substance';
          }
        } else {
          element.errorDetails = 'Invalid Substance';
        }
      });
      this.loading = false;
      console.log(this.substanceOptions);
      this.validateOtherDetailsforRecipe();
    }, (error) => {
      this.recipeValidated = 0;
      this.loading = false;
    });
  }
  createRecipeModel() {


  }
  calculateingQtySIRQty() {
    if (this.segregatecompositionData.length > 0) {
      const seen = new Set();
      let totalIngredientPer = 0;
      let totalSIRQty = 0;
      this.segregatecompositionData.forEach(item => {
        totalSIRQty += Number(item.sirQty);
        if (!seen.has(item.ingID)) {
          seen.add(item.ingID);
          totalIngredientPer += Number(item.ingredientPer);
        }
      });
      this.calculatedINGQty = this.roundIfMoreThan6Decimals(totalIngredientPer);
      this.calculatedSIRQty = this.roundIfMoreThan6Decimals(totalSIRQty);
    }
    this.invalidTotalINGCalc = false;
    this.invalidTotalSIRCalc = false;
    if (!(this.isValidTotalRange(this.calculatedINGQty, 'ING'))) {
      this.recipeValidated = 0;
      this.invalidTotalINGCalc = true;
    }
    if (!(this.isValidTotalRange(this.calculatedSIRQty, ''))) {
      this.recipeValidated = 0;
      this.invalidTotalSIRCalc = true;
    }
  }
  isValidTotalRange(quantity, isING): boolean {
    let isinvalidValidRange = true;
    if (isING) {
      isinvalidValidRange = (this.roundIfMoreThan6Decimals(parseFloat(quantity)) >= 99.99 && this.roundIfMoreThan6Decimals(parseFloat(quantity)) <= 100.01);
    } else {
      isinvalidValidRange = (this.roundIfMoreThan6Decimals(parseFloat(quantity)) >= 99.99 && this.roundIfMoreThan6Decimals(parseFloat(quantity)) <= 100.01);
    }
    return isinvalidValidRange;
  }
  loadIngredientTable() {
    this.segregatecompositionData = this.segregatecompositionData.concat(this.ingredientListData);
  }
  updateEditIngvaluetoMain() {
    this.tempCompositionData = this.segregatecompositionData;
    this.tempCompositionData = this.tempCompositionData.filter(f => f.ingID !== this.editIngTable1Data[0].oldingID);
    this.segregatecompositionData = [];
    let substanceRow = {};
    if (this.editIngTable1Data[0].ingID === '--') {
      this.loadingmappinglistMessage = 'Fetching data from PLM';
      this.loading = true;
      const apiurl = environment.APIFAsT + '/generateuniqueingid/localing';
      this.apiService.getData(apiurl).subscribe((response) => {
        this.loading = false;
        this.uniqLocalIngID = response;
        if (this.uniqLocalIngID !== undefined) {
          this.editIngTable1Data[0].ingID = this.uniqLocalIngID[0];
          this.substanceListOfEditIng.forEach(element => {
            const sirQtyCalculated = (Number(this.editIngTable1Data[0].ingQuantity) * element.sirPercentageInIng) / 100;
            substanceRow = {
              ingID: this.editIngTable1Data[0].ingID,
              ingName: this.editIngTable1Data[0].ingDescription,
              ingredientPer: this.editIngTable1Data[0].ingQuantity,
              subName: element.subName,
              sirId: element.sirId,
              sirPercentageInIng: element.sirPercentageInIng,
              casNumber: element.casNumber,
              einecs: element.einecs,
              errorDetails: element.errorDetails,
              inciName: element.inciName,
              pureCode: element.pureCode,
              sirQty: sirQtyCalculated,
              uom: element.uom,
              isTemporaryIngredient: 1
            };
            this.segregatecompositionData.push(substanceRow);
          });
        }
      }, (error) => {
        this.loading = false;
        console.log(error);
      });
    } else {
      // If ingredient ID remains unchanged
      this.substanceListOfEditIng.forEach(element => {
        const sirQtyCalculated = (Number(this.editIngTable1Data[0].ingQuantity) * element.sirPercentageInIng) / 100;
        substanceRow = {
          ingID: this.editIngTable1Data[0].ingID,
          ingName: this.editIngTable1Data[0].ingDescription,
          ingredientPer: this.editIngTable1Data[0].ingQuantity,
          subName: element.subName,
          sirId: element.sirId,
          sirPercentageInIng: element.sirPercentageInIng,
          casNumber: element.casNumber,
          einecs: element.einecs,
          errorDetails: element.errorDetails,
          inciName: element.inciName,
          pureCode: element.pureCode,
          sirQty: sirQtyCalculated,
          uom: element.uom,
          isTemporaryIngredient: 0
        };
        this.segregatecompositionData.push(substanceRow);
      });
    }
    this.segregatecompositionData = this.segregatecompositionData.concat(this.tempCompositionData);
    this.editIngredientDialog = false;
  }
  openEditIngPopUp(ingMapping) {
    console.log('Clicked pencil Icon');
    console.log(ingMapping);
    this.editIngSelection = ingMapping._selection;
    this.editIngTable1Data = [{
      ingID: this.editIngSelection.ingID,
      ingDescription: this.editIngSelection.ingName,
      ingQuantity: this.editIngSelection.ingredientPer,
      oldingID: this.editIngSelection.ingID,
      isTemporaryIngredient: this.editIngSelection.isTemporaryIngredient
    }];
    this.getSubstanceListOfEditIng(this.editIngSelection.ingID);
    this.updateTotalSirPercent();
    this.editIngredientDialog = true;
    this.validateEditIngPopup();
  }
  closeEditIngPopup() {
    this.onClearEditIngredient();
    this.editIngredientDialog = false;
  }
  resetEditIngIngredientID() {
    if (this.editIngTable1Data[0].isTemporaryIngredient === 0) {
      this.editIngTable1Data[0].ingID = '--';
    }
  }
  showIngDeleteConfirmation() {
    this.showConfirmDelete = true;
  }
  deleteIng() {
    this.editIngTable1Data[0].ingQuantity = 0;
    this.editIngTable1Data[0].ingID = '--';
    this.substanceListOfEditIng = [];
    this.tempCompositionData = this.segregatecompositionData;
    this.segregatecompositionData = [];
    this.segregatecompositionData = this.tempCompositionData.filter(f => f.ingID !== this.editIngTable1Data[0].oldingID);
    this.showConfirmDelete = false;
    this.editIngredientDialog = false;
  }

  validateEditIngQty(value: string) {
    this.editIngTable1Data[0].ingQuantity = value;
    this.validateEditIngPopup();
  }
  validateEditIngPopup() {
    this.popupNotValidated = false;
    if (this.substanceListOfEditIng.length <= 0) {
      this.popupNotValidated = true;
    }
    if (this.totalSirPercent < 99.9 || this.totalSirPercent > 100.02) {
      this.popupNotValidated = true;
    }
    if (this.editIngTable1Data[0].ingQuantity <= 0) {
      this.popupNotValidated = true;
    }
    this.substanceListOfEditIng.forEach(element => {
      if (element.sirPercentageInIng === undefined || element.sirPercentageInIng <= 0 || element.sirPercentageInIng > 100) {
        this.popupNotValidated = true;
      }
    });
  }

  confirmNo() {
    this.showConfirmDelete = false;
  }

  //  checkAndConvertNumber(value) {
  //   if (typeof value === 'number') {
  //     return value; // It's already a number
  //   }
  //   if (typeof value === 'string') {
  //     const num = Number(value);
  //     if (!isNaN(num)) {
  //       return num; // Successfully converted to a number
  //     }
  //   }
  //   return NaN; // Return NaN if it's not a number or can't be converted
  // }

  addSubstancefrom1starsearchtoEditIngList(onestarIngID, validityArea, keyDate, plm = false, index = 0) {
    this.loadingmappinglistMessage = 'Fetching data from PLM';
    this.loading = true;
    if (plm) {
      this.importFromPLMDetail[index].errorMessagePlm = '';
    }

    if (!this.isValidIng(onestarIngID)) {
      this.loading = false;
      this.errorMessage = 'Invalid 1* Ingredient ID';
      if (plm) {
        this.importFromPLMDetail[index].errorMessagePlm = 'Invalid 1* Ingredient ID';
      }
      return false;
    }
    if (onestarIngID === this.editIngTable1Data[0].ingID) {
      this.loading = false;
      this.errorMessage = 'Substances in this ingredient are already present.';
      return false;
    }
    const apiurl = environment.APIFAsT + '/ingcode/' + onestarIngID + '/plmvalidityarea/' + validityArea.validityAreaCode + '/plmkeydate/20250507';
    let substance = {};
    const duplicateSubstanceList = [];
    const ingID = onestarIngID;
    this.apiService.getData(apiurl).subscribe((response) => {
      this.loading = false;
      this.OneStarAPIResponse = response;
      if (this.OneStarAPIResponse.ingPureDetails !== undefined && !plm) {
        this.OneStarAPIResponse.ingPureDetails.forEach(c => {
          // duplicacy check for substances in substance grid while importing data for 1* ingredient
          if (this.substanceListOfEditIng.filter(f => f.sirId === c.substanceID).length <= 0) {
            substance = {
              subName: c.substanceName,
              sirId: c.substanceID,
              sirPercentageInIng: c.recipeQuantity,
              pureCode: c.pureCode,
              casNumber: c.casNumber,
              inciName: c.inciNumber,
              einecs: c.einecsNumber,
              uom: c.recipeUoM
            };
            this.substanceListOfEditIng.push(substance);
          } else {
            duplicateSubstanceList.push(c.substanceName);
          }
          this.updateTotalSirPercent();
          onestarIngID = '';
          this.validateEditIngPopup();
        });
        if (duplicateSubstanceList.length > 0) {
          const duplicateSubCommaSeparated = duplicateSubstanceList.join(', ');
          if (duplicateSubstanceList.length === 1) {
            this.errorMessage = 'Substance ' + duplicateSubCommaSeparated + ' from ' + ingID + ' is not added, as it was already present.';
          } else {
            this.errorMessage = 'Substances ' + duplicateSubCommaSeparated + ' from ' + ingID + ' are not added, as they were already present.';
          }
        }

      }
      if (this.OneStarAPIResponse.ingPureDetails !== undefined && plm) {
        this.OneStarAPIResponse.ingPureDetails.forEach(c => {
          if (this.importFromPLMDetail[index].ingPureDetails.filter(f => f.substanceID === c.substanceID).length <= 0) {
            substance = {
              substanceName: c.substanceName,
              substanceID: c.substanceID,
              pureQuantityPerItem: parseFloat(c.recipeQuantityToDisplay),
              delId: Math.random(),
              pureCode: c.pureCode,
              casNumber: c.casNumber,
              inciNumber: c.inciNumber,
              einecsNumber: c.einecsNumber,
              recipeUoM: c.recipeUoM
            };
            this.importFromPLMDetail[index].ingPureDetails.push(substance);
            this.importFromPLMDetail[index].ingID = '--';
          } else {
            duplicateSubstanceList.push(c.substanceName);
          }
        });
        if (duplicateSubstanceList.length > 0) {
          const duplicateSubCommaSeparated = duplicateSubstanceList.join(', ');
          if (duplicateSubstanceList.length === 1) {
            this.importFromPLMDetail[index].errorMessagePlm = 'Substance ' + duplicateSubCommaSeparated + ' from ' + ingID + ' is not added, as it was already present.';
          } else {
            this.importFromPLMDetail[index].errorMessagePlm = 'Substances ' + duplicateSubCommaSeparated + ' from ' + ingID + ' are not added, as they were already present.';
          }
        }

        this.updateTotalSirPercentplm();
        onestarIngID = '';
        // this.importFromPLMDetail = this.addSerialNumbers(this.importFromPLMDetail);
      }
      this.resetEditIngIngredientID();
    }, (error) => {
      this.loading = false;
    });
  }
  getvalidityArea() {
    const apiurl = environment.APIFAsT + '/getvalidityarea';
    this.apiService.getData(apiurl).subscribe((response1) => {
      this.validityAreavals = response1;
      this.validityarea = this.validityAreavals.filter(s => s.validityAreaCode === 'WORLD')[0];
      this.plmvalidityareaedit = this.validityAreavals.filter(s => s.validityAreaCode === 'WORLD')[0];
    }, (error) => {
    });
  }
  getSubstanceListOfEditIng(ingID) {
    this.substanceListOfEditIng = [];
    this.segregatecompositionData.forEach(element => {
      let substance = {};
      if (element.ingID === ingID) {
        substance = {
          subName: element.subName,
          sirId: element.sirId,
          sirPercentageInIng: element.sirPercentageInIng,
          casNumber: element.casNumber,
          einecs: element.einecs,
          errorDetails: element.errorDetails,
          inciName: element.inciName,
          pureCode: element.pureCode,
          sirQty: element.sirQty,
          uom: element.uom,
          ingredientPer: element.ingredientPer,
          ingID: element.ingID,
          ingName: element.ingName,
          isTemporaryIngredient: element.isTemporaryIngredient
        };
        this.substanceListOfEditIng.push(substance);
      }
    });
    console.log(this.substanceListOfEditIng);

  }
  selectRow(row) {
    if (row._selection === null || row._selection === undefined) {
      this.buttonSelection = false;
    } else {
      this.buttonSelection = true;
    }
  }
  checkval(event) {
    if (event.target.value === '') {
      console.log(this.sirSearchResult);
      this.sirSearchResult = [];
      console.log(this.sirSearchResult);
      this.disablePureCode = false;
      this.searchIdentifierValue = null;
      this.sirDetails = [];
      this.sirObjSelectedIndex = null;
      this.showPuremsg = false;
      this.substanceOptions = [];
    }
  }

  searchSubstance(searchIdentifierValue, index = 0, calledFromImportFromPlm = false) {
    if (searchIdentifierValue === '') {
      searchIdentifierValue = this.searchIdentifierValue;
    }
    this.loading = true;
    this.loadingmappinglistMessage = 'Fetching Substances details';
    this.substanceOptions = [];
    this.errorMessage = '';
    if (calledFromImportFromPlm) {
      this.importFromPLMDetail[index].errorMessagePlm = '';
    }
    const apiurl = environment.APIFAsT + '/substancesfornonplm/' + searchIdentifierValue;
    this.apiService.getData(apiurl).subscribe((response1) => {
      this.sirSearchResult = response1;
      this.loading = false;
      if (this.sirSearchResult[0] === null) {
        this.loading = false;
        this.errorMessage = 'No substances found.';
        if (calledFromImportFromPlm) {
          this.importFromPLMDetail[index].errorMessagePlm = 'No substances found.';
        }
        return false;
      }
      console.log(this.sirSearchResult);
      this.sirSearchResult.forEach(parent => {
        const subDetails = {
          pureCodeLst: [],
          pureCode: '',
          subName: parent.backboneIdentity,
          sirId: parent.sirIdentity,
          casNumber: '',
          inciName: '',
          einecs: ''
        };
        parent.names.forEach(child => {
          if (child.nameType === 'CAS') {
            subDetails.casNumber = child.name;
          } else if (child.nameType === 'INCI') {
            subDetails.inciName = child.name;
          } else if (child.nameType === 'EINECS') {
            subDetails.einecs = child.name;
          } else if (child.nameType === 'PLM Pure') {
            subDetails.pureCodeLst.push(child.name);
          }
        });
        const pureCodeInCommaSeparated = subDetails.pureCodeLst.join(',');
        subDetails.pureCode = pureCodeInCommaSeparated;
        this.substanceOptions.push({
          label: parent.backboneIdentity,
          value: subDetails,
          isParent: true
        });
        parent.names.forEach(child => {
          this.substanceOptions.push({
            label: child.name,
            value: subDetails,
            isParent: false
          });
        });
      });
    }, (error) => {
      this.loading = false;
    });
    console.log(this.substanceOptions);

  }
  updateSubstanceTable() {
    this.errorMessage = '';
    if (this.selectedSubstance && this.selectedSubstance.subName && this.selectedSubstance.sirId) {
      if (this.substanceListOfEditIng.filter(f => f.sirId === this.selectedSubstance.sirId).length <= 0) {
        this.substanceListOfEditIng.push({
          subName: this.selectedSubstance.subName,
          sirId: this.selectedSubstance.sirId,
          sirPercentageInIng: 0,
          casNumber: this.selectedSubstance.casNumber,
          einecs: this.selectedSubstance.einecs,
          inciName: this.selectedSubstance.inciName,
          pureCode: this.selectedSubstance.pureCode,
          uom: '%'
        });
      } else {
        this.errorMessage = 'This substance is already present in substance list.';
      }
    }
    this.resetEditIngIngredientID();
    this.validateEditIngPopup();
  }

  plmUpdateSubstanceTable(index) {
    this.importFromPLMDetail[index].errorMessagePlm = '';
    if (this.importFromPLMDetail[index].childselectedSubstance && this.importFromPLMDetail[index].childselectedSubstance.subName && this.importFromPLMDetail[index].childselectedSubstance.sirId) {
      if (this.importFromPLMDetail[index].ingPureDetails.filter(f => f.substanceID === this.importFromPLMDetail[index].childselectedSubstance.sirId).length <= 0) {
        const substance = {
          substanceName: this.importFromPLMDetail[index].childselectedSubstance.subName,
          substanceID: this.importFromPLMDetail[index].childselectedSubstance.sirId,
          pureQuantityPerItem: 0,
          delId: Math.random(),
          casNumber: this.importFromPLMDetail[index].childselectedSubstance.casNumber,
          einecsNumber: this.importFromPLMDetail[index].childselectedSubstance.einecs,
          inciNumber: this.importFromPLMDetail[index].childselectedSubstance.inciName,
          pureCode: this.importFromPLMDetail[index].childselectedSubstance.pureCode,
          recipeUoM: '%'

        };
        this.importFromPLMDetail[index].ingPureDetails.push(substance);
        this.importFromPLMDetail[index].ingID = '--';
        this.submitEnableDisable();
      } else {
        this.importFromPLMDetail[index].errorMessagePlm = 'This substance is already present in substance list.';

      }
    }
    console.log(this.substanceListOfEditIng);
  }

  onSelectionChange(event: any) {
    const selectedItem = event.value;
    this.isAddSubstanceEnable = false;
    if (selectedItem === null) {
      this.selectedSubstance = null;
      this.isAddSubstanceEnable = true;
    }
  }

  updateTotalSirPercent() {
    let totalSum = 0;
    this.substanceListOfEditIng.forEach(element => {
      totalSum = totalSum + element.sirPercentageInIng;
    });
    this.totalSirPercent = totalSum;
    this.validateEditIngPopup();
  }

  // updateTotalSirPercentplm(i = 0) {
  //   let totalSum = 0;
  //   this.importFromPLMDetail.forEach(e => {
  //     e.ingPureDetails.forEach(c => {
  //       if (c.pureQuantityPerItem !== '') {
  //         totalSum = totalSum + parseFloat(c.pureQuantityPerItem);
  //       }
  //     });
  //     e.totalSirPercent = totalSum;
  //     totalSum = 0;
  //   });
  //   this.submitEnableDisable();
  // }

  resetPlmIngIngredientID(index) {
    this.importFromPLMDetail[index].ingID = '--';
  }
  deleteSubstance(index: number) {
    this.substanceListOfEditIng.splice(index, 1);
    this.updateTotalSirPercent();
    this.resetEditIngIngredientID();
  }
  // getSubstanceDetails() {
  //   this.groupedChemicals = [
  //     {
  //       label: 'Citric Acid',
  //       items: [
  //         { label: 'Citric Acid', value: 'Citric Acid' },
  //         { label: 'Citric Adic (E330)', value: 'Citric Acid E330' }
  //       ]
  //     },
  //     {
  //       label: 'Citric Acid - Anhydrous',
  //       items: [
  //         { label: 'Anhydrous', value: 'Citric Acid' },
  //         { label: 'Citric Acid - Anhydrous', value: 'Citric Acid-Anhy' }
  //       ]
  //     }
  //   ];
  // }
  opendialogImportPLM() {
    this.importfromPlm = true;
    this.importFromPLMDetail = [];
    this.cucaltver = '';
    this.errorMessage = '';
  }
  importfromPLM() {
    this.loading = true;
    this.loadingmappinglistMessage = 'Fetching data from PLM';
    console.log(this.validityarea, 'validityarea');
    const keydate = this.datePipe.transform(this.keydate, 'yyyyMMdd');
    const getimportFromPLM = environment.APIFAsT + '/recipe/' + this.cucaltver + '/recipieType/Z_General/plmvalidityarea/' + this.validityarea.validityDescription + '/plmkeydate/' + keydate;
    // const getimportFromPLM = environment.APIFAsT + '/recipe/200000279962/000/000/recipieType/Z_General/plmvalidityarea/undefined/plmkeydate/20250430';
    this.assessRequestRa.getData(getimportFromPLM).subscribe((result) => {
      this.importFromPLMDetail = this.importFromPLMDetail.concat(result.formulationRequestDetailsIng);
      this.importFromPLMDetail = this.addSerialNumbers(this.importFromPLMDetail);
      this.importFromPLMDetail = this.removeDuplicates(this.importFromPLMDetail, 'ingPureDetails', 'substanceID');
      this.updateTotalSirPercentplm();
      this.loading = false;
      this.submitEnableDisable();
      this.tfcDetailsfromPlm = result.tfc;
    }, (error) => {
      this.loading = false;
      this.matSnackBar.open(error.error.message, 'close', {
        duration: 3000,
        panelClass: ['error']
      });
    });
  }

  removeDuplicates(arr, childKey, idKey) {
    const seenIds = new Set();
    return arr.map(obj => {
      if (obj[childKey] && Array.isArray(obj[childKey])) {
        obj[childKey] = obj[childKey].filter(child => {
          if (seenIds.has(child[idKey])) {
            return false; // Skip if ID is already seen
          } else {
            seenIds.add(child[idKey]);
            return true;  // Keep if ID is new
          }
        });
        seenIds.clear();
      }
      return obj;
    });
  }

  addIngredientDialogPlm() {
    const newrow = {
      specSerial: null,
      specID: null,
      isLocalIng: null,
      specDescription: null,
      specQuantity: 0.0,
      specUoM: null,
      ingID: '--',
      ingDescription: '',
      ingQuantity: '',
      ingUoM: null,
      ingType: '',
      ingError: null,
      ingPureDetails: [],
      otherRuleResults: null,
      delId: Math.random(),
      childingid: '',
      childvalidityArea: this.validityAreavals.filter(s => s.validityAreaCode === 'WORLD')[0],
      childkeydate: new Date(),
      childsearchIdentifierValue: '',
      childselectedSubstance: [],
      errorMessagePlm: ''
    };
    this.importFromPLMDetail.push(newrow);
    this.addSerialNumbers(this.importFromPLMDetail);
    this.submitEnableDisable();
  }
  importfromSubstance() {

  }
  importfromPLM1() {

  }
  onClearFilters() {
    this.cucaltver = '';
    this.validityarea = this.validityAreavals.filter(s => s.validityAreaCode === 'WORLD')[0];
    this.keydate = new Date();
  }

  onClearEditIngredient() {
    this.onestarIngID = '';
    this.plmvalidityareaedit = this.validityAreavals.filter(s => s.validityAreaCode === 'WORLD')[0];
    this.plmkeydate = '';
    this.searchIdentifierValue = '';
    this.selectedSubstance = '';
    this.substanceOptions = [];
    this.errorMessage = '';
  }
  searchValidityArea(event) {
    const filtered: any[] = [];
    const query = event.query;
    for (const value of this.validityAreavals) {
      this.validityAreaVal = value.validityDescription;
      if (this.validityAreaVal.toLowerCase().includes(query.toLowerCase())) {
        filtered.push(this.validityAreaVal);
      }
    }
    this.filteredvalidityArea = filtered;
  }
  convertToDateFormat(date) {
    const year = date.substring(0, 4);
    const month = date.substring(4, 6);
    const day = date.substring(6, 8);
    const displayDate = day + '-' + month + '-' + year;
    return displayDate;
  }
  test(event, mc) {
    this.formAssess.plmkeydate = mc.inputFieldValue;
  }
  onTabClick(activeTab) {
    this.activeTab = activeTab;
    localStorage.removeItem('FormObj');
  }
  onCucChanged() {

  }
  deleteIngrow(pId) {
    console.log('In delete Ing');
    this.importFromPLMDetail = this.importFromPLMDetail.filter(item => item.delId !== pId);
    this.submitEnableDisable();
  }
  deleteIngclildrow(cId, i) {
    console.log('In delete Ing');
    this.importFromPLMDetail = this.deleteObjectFromNestedArray(this.importFromPLMDetail, cId);
    this.importFromPLMDetail[i].ingID = '--';
    this.updateTotalSirPercentplm();
  }

  submitEnableDisable() {
    this.isplmDataValid = false;
    const arr100 = [];
    const checkblank = [];
    this.importFromPLMDetail.forEach(e => {
      checkblank.push(e.ingDescription);
      checkblank.push(e.ingQuantity);
      arr100.push(e.totalSirPercent);
      e.ingPureDetails.forEach(c => {
        checkblank.push(parseFloat(c.pureQuantityPerItem));
      });
    });
    if (arr100.every(element => element === 100) && checkblank.every(element => element !== '') && checkblank.every(element => element !== 0) && checkblank.every(element => element !== '0')) {
      this.isplmDataValid = true;
    }

  }
  addSerialNumbers(arr) {
    return arr.map((obj, index) => {
      const newObj = { ...obj, delId: index + 1, childingid: '', childvalidityArea: this.validityAreavals.filter(s => s.validityAreaCode === 'WORLD')[0], childkeydate: new Date(), searchIdentifierValue: '', selectedSubstance: [], errorMessagePlm: '' };
      if (obj.ingPureDetails && Array.isArray(obj.ingPureDetails)) {
        newObj.ingPureDetails = obj.ingPureDetails.map((child, childIndex) => ({
          ...child,
          delId: `${index + 1}.${childIndex + 1}`,
        }));
      }
      return newObj;
    });
  }

  deleteObjectFromNestedArray(arr, idToDelete) {
    for (let i = 0; i < arr.length; i++) {
      if (Array.isArray(arr[i])) {
        arr[i] = arr[i].filter(item => item.delId !== idToDelete);
      } else if (typeof arr[i] === 'object' && arr[i] !== null) {
        for (const key in arr[i]) {
          if (Array.isArray(arr[i][key])) {
            arr[i][key] = arr[i][key].filter(item => item.delId !== idToDelete);
          }
        }
      }
    }
    return arr;
  }
  // Starts ADD ING Related Functions
  onAddINGTabClick(activeTab) {
    this.loadingmappinglistMessage = activeTab === 'divSIR' ? 'Fetching SIR details' : 'Fetching ING details';
  }
  selectedKeyDate(event, mc) {
    this.plmkeydate = mc.inputFieldValue;
  }
  onValidityAreaChanged(selectedData) {
    this.plmvalidityarea = selectedData.validityAreaCode;
    if (this.plmvalidityarea === undefined) {
      this.plmvalidityarea = this.validityarea.validityAreacode;
      this.additionalfielderror = false;
    } else {
      this.additionalfielderror = false;
    }
    /* istanbul ignore if */
    if (selectedData === undefined) {
      this.plmkeydate = this.defaultStartDate;
    }
  }
  GetINGData() {
    this.loading = true;
    this.errorMessage = '';
    this.loadingmappinglistMessage = 'Fetching ING Details';
    if (!this.isValidIng(this.ingredientIdOrName)) {
      this.loading = false;
      this.errorMessage = 'Invalid 1* Ingredient ID';
      return false;
    }
    const apiurl = environment.APIFAsT + '/ingcode/' + this.ingredientIdOrName + '/plmvalidityarea/' + this.plmvalidityarea + '/plmkeydate/' + this.convertDateToyyyyMMdd(this.plmkeydate);
    this.apiService.getData(apiurl).subscribe((response1) => {
      this.loading = false;
      if (response1 === null) {
        return false;
      }
      this.ingResponseData = response1;
      if (this.substanceDetailsData.length > 0) {
        this.setHypenToIngID();
      } else {
        this.createIngHeaderInformation(this.ingResponseData.ingID, this.ingResponseData.ingDescription, this.ingResponseData.ingQuantity);
      }
      const duplicateSubstanceList = [];
      const ingID = this.ingredientIdOrName;
      this.ingResponseData.ingPureDetails.forEach(element => {
        if (this.substanceDetailsData.length > 0) {
          const exists = this.substanceDetailsData.some(detailsData => detailsData.substanceID === element.substanceID && detailsData.substanceName === element.substanceName);
          if (!exists) {
            this.substanceDetailsData.push(element);
          } else {
            duplicateSubstanceList.push(element.substanceName);
          }
        } else {
          this.substanceDetailsData.push(element);
        }
      });
      if (duplicateSubstanceList.length > 0) {
        const duplicateSubCommaSeparated = duplicateSubstanceList.join(', ');
        if (duplicateSubstanceList.length === 1) {
          this.errorMessage = 'Substance ' + duplicateSubCommaSeparated + ' from ' + ingID + ' is not added, as it was already present.';
        } else {
          this.errorMessage = 'Substances ' + duplicateSubCommaSeparated + ' from ' + ingID + ' are not added, as they were already present.';
        }
      }
      this.updateTotalAddIngSirPercent();
      this.loading = false;
    }, (error) => {
      this.loading = false;
    });
  }
  isImportAddEnable() {
    if (this.ingredientIdOrName !== '' && this.plmvalidityarea !== '' && this.plmkeydate !== '') {
      return true;
    } else {
      return false;
    }
  }
  cancelPopup() {
    this.clearAll();
    this.addIngredient = false;
  }
  updateTotalAddIngSirPercent() {
    let totalSum = 0;
    this.substanceDetailsData.forEach(element => {
      totalSum = totalSum + element.recipeQuantity;
    });
    this.totalSirPercent = totalSum;
    this.disableIngSubmitButton();
  }
  deleteAddIngSubstance(index: number) {
    this.setHypenToIngID();
    this.substanceDetailsData.splice(index, 1);
    this.updateTotalAddIngSirPercent();
  }
  deleteAddIng() {
    this.ingHeaderDataInformation = [];
    this.substanceDetailsData = [];
    this.totalSirPercent = 0;
  }
  clearAll() {
    this.ingredientIdOrName = '';
    this.validityarea = this.validityAreavals.filter(s => s.validityAreaCode === 'WORLD')[0];
    this.plmvalidityarea = this.validityarea.validityAreacode;
    this.plmkeydate = this.defaultStartDate;
    this.errorMessage = '';
    this.isAddSubstanceEnable = true;
    this.searchIdentifierValue = '';
    this.substanceOptions = [];
    this.selectedSubstance = '';
  }
  isValidIng(ingValue) {
    const isNumeric = /^\d+$/.test(ingValue);
    let isValid = true;
    if (isNumeric) {
      isValid = /^1\d{11}$/.test(ingValue);
    }
    return isValid;
  }
  submitIngDetails() {
    this.tempCompositionData = this.segregatecompositionData;
    if (this.tempCompositionData.length > 0 && this.tempCompositionData.filter(f => f.ingID === this.ingHeaderDataInformation[0].ingID).length > 0) {
      this.errorMessage = 'This ING ID ' + this.ingHeaderDataInformation[0].ingID + ' exists under Composition Details.';
      return false;
    }
    this.tempCompositionData = this.tempCompositionData.filter(f => f.ingID !== this.ingHeaderDataInformation[0].ingID);
    this.segregatecompositionData = [];
    let substanceRow = {};
    if (this.ingHeaderDataInformation[0].ingID === '--') {
      this.loadingmappinglistMessage = 'Fetching data from PLM';
      this.loading = true;
      const apiurl = environment.APIFAsT + '/generateuniqueingid/localing';
      this.apiService.getData(apiurl).subscribe((response) => {
        this.loading = false;
        this.uniqLocalIngID = response;
        if (this.uniqLocalIngID !== undefined) {
          this.ingHeaderDataInformation[0].ingID = this.uniqLocalIngID[0];
          this.substanceDetailsData.forEach(element => {
            substanceRow = {
              ingID: this.ingHeaderDataInformation[0].ingID,
              ingName: this.ingHeaderDataInformation[0].ingDescription,
              ingredientPer: this.ingHeaderDataInformation[0].ingQuantity,
              subName: element.substanceName.trim(),
              sirId: element.substanceID.trim(),
              sirPercentageInIng: element.recipeQuantity,
              casNumber: element.casNumber,
              einecs: element.einecsNumber,
              errorDetails: element.substanceError,
              inciName: element.inciNumber,
              pureCode: element.pureCode,
              sirQty: (this.ingHeaderDataInformation[0].ingQuantity * element.recipeQuantity) / 100,
              uom: element.recipeUoM,
              isTemporaryIngredient: 1
            };
            this.segregatecompositionData.push(substanceRow);
          });
        }
      }, (error) => {
        this.loading = false;
      });
    } else {
      // If ingredient ID remains unchanged
      this.substanceDetailsData.forEach(element => {
        substanceRow = {
          ingID: this.ingHeaderDataInformation[0].ingID,
          ingName: this.ingHeaderDataInformation[0].ingDescription,
          ingredientPer: this.ingHeaderDataInformation[0].ingQuantity,
          subName: element.substanceName.trim(),
          sirId: element.substanceID.trim(),
          sirPercentageInIng: element.recipeQuantity,
          casNumber: element.casNumber,
          einecs: element.einecsNumber,
          errorDetails: element.substanceError,
          inciName: element.inciNumber,
          pureCode: element.pureCode,
          sirQty: (this.ingHeaderDataInformation[0].ingQuantity * element.recipeQuantity) / 100,
          uom: element.recipeUoM,
          isTemporaryIngredient: 0
        };
        this.segregatecompositionData.push(substanceRow);
      });
    }
    this.segregatecompositionData = this.segregatecompositionData.concat(this.tempCompositionData);
    this.calculateingQtySIRQty();
    this.addIngredient = false;
  }
  setHypenToIngID() {
    if (this.ingHeaderDataInformation.length > 0) {
      this.ingHeaderDataInformation[0].ingID = '--';
    }

  }
  onInputChange(event) {
    this.errorMessage = '';
    const value = (event.target as HTMLInputElement).value;
    if (value !== this.ingHeaderDataInformation[0].ingID) {
      this.setHypenToIngID();
    }
    this.disableIngSubmitButton();
  }
  addSIRSubstanceTable() {
    this.errorMessage = '';
    let isItemNotExists = true;
    // if Ingredient information exists then setting '--' for Ingredient ID.
    if (this.substanceDetailsData.length > 0) {
      this.setHypenToIngID();
    } else { // if No Ingredient information then by default setting with below values.
      this.createIngHeaderInformation('--', '', 0);
    }
    if (this.selectedSubstance && this.selectedSubstance.subName && this.selectedSubstance.sirId) {
      const names = this.sirSearchResult.filter(f => f.sirIdentity === this.selectedSubstance.sirId)[0].names;
      if (this.substanceDetailsData.length > 0) {
        const exists = this.substanceDetailsData.some(detailsData => detailsData.substanceID === this.selectedSubstance.sirId && detailsData.substanceName === this.selectedSubstance.subName);
        isItemNotExists = false;
        if (!exists) {
          isItemNotExists = true;
        }
      }
      if (isItemNotExists) {
        const eNumber = names.filter(n => n.nameType.toLowerCase() === 'e number');
        const einecs = names.filter(n => n.nameType.toLowerCase() === 'einecs');
        const inci = names.filter(n => n.nameType.toLowerCase() === 'inci');
        const cas = names.filter(n => n.nameType.toLowerCase() === 'cas');
        const plmPure = names.filter(n => n.nameType.toLowerCase() === 'plm pure');
        this.substanceDetailsData.push({
          casNumber: cas.length > 0 ? cas[0].name : '',
          convFactor: 0,
          eNumber: eNumber.length > 0 ? eNumber[0].name : '',
          einecsNumber: einecs.length > 0 ? einecs[0].name : '',
          inciNumber: inci.length > 0 ? inci[0].name : '',
          ingredientPath: null,
          insNumber: null,
          originalRecipeQuantity: null,
          parentCASNumber: '',
          pureCode: plmPure.length > 0 ? plmPure[0].name : '',
          pureDescription: '',
          pureQuantityPerItem: 0,
          pureSerial: null,
          recipeQuantity: this.selectedSubstance.sirPercentageInIng === undefined ? '' : this.selectedSubstance.sirPercentageInIng,
          recipeQuantityToDisplay: '0.000',
          recipeUoM: '%',
          substanceError: this.selectedSubstance.sirId.trim() === '' ? 'SIR ID not found' : 'No Issues',
          substanceID: this.selectedSubstance.sirId.trim(),
          substanceName: this.selectedSubstance.subName.trim(),
        });
      } else {
        this.errorMessage = 'This substance is already present in substance list.';
      }
    }
    this.disableIngSubmitButton();
  }
  createIngHeaderInformation(ingId, ingDescription, ingQuantity) {
    this.ingHeaderDataInformation = [];
    this.ingHeaderData.ingID = ingId;
    this.ingHeaderData.ingDescription = ingDescription;
    this.ingHeaderData.ingQuantity = ingQuantity === 0 ? null : ingQuantity;
    this.ingHeaderDataInformation.push(this.ingHeaderData);
  }
  convertDateToyyyyMMdd(inputDate) {
    const parts = inputDate.split('-');
    return this.datePipe.transform(new Date(+parts[2], +parts[1] - 1, +parts[0]), 'yyyyMMdd');
  }
  disableIngSubmitButton() {
    this.isIngValidData = true;
    if (this.ingHeaderDataInformation[0].ingID === '' || this.ingHeaderDataInformation[0].ingDescription === '' || this.ingHeaderDataInformation[0].ingQuantity === null || this.ingHeaderDataInformation[0].ingQuantity === '0') {
      this.isIngValidData = false;
    }
    if (this.totalSirPercent !== 100) {
      this.isIngValidData = false;
    }
    if (this.isIngValidData) {
      this.substanceDetailsData.forEach(s => {
        if (s.substanceName === '' || s.substanceID === '' || s.recipeQuantity <= 0 || s.substanceID === null) {
          this.isIngValidData = false;
        }
      });
    }
  }
  // Ends ADD ING Related Functions

  onClearTableData(index) {
    this.importFromPLMDetail[index].childingid = '';
    this.importFromPLMDetail[index].childvalidityArea = this.validityAreavals.filter(s => s.validityAreaCode === 'WORLD')[0];
    this.importFromPLMDetail[index].childkeydate = new Date();
  }

  submitCreatePlmDetails() {
    console.log(this.importFromPLMDetail, 'this.importFromPLMDetail');

    this.tempCompositionData = this.segregatecompositionData;
    const alreadyexistIng = [];
    this.importFromPLMDetail.forEach(e => {
      if (this.tempCompositionData.length > 0 && this.tempCompositionData.filter(f => f.ingID === e.ingID).length > 0) {
        alreadyexistIng.push(e.ingID);
      }
    });
    if (alreadyexistIng.length > 0) {
      this.errorMessage = 'ING IDs ' + alreadyexistIng.join(',') + ' already exists under Composition Details. Please delete these INGs to proceed.';
    } else {
      this.errorMessage = '';
      this.segregatecompositionData = [];
      this.importFromPLMDetail.forEach(e => {
        this.tempCompositionData = this.tempCompositionData.filter(f => f.ingID !== e.ingID);

        let substanceRow = {};
        if (e.ingID === '--') {
          this.loadingmappinglistMessage = 'Fetching data from PLM';
          this.loading = true;
          const apiurl = environment.APIFAsT + '/generateuniqueingid/localing';
          this.apiService.getData(apiurl).subscribe((response) => {
            this.loading = false;
            this.uniqLocalIngID = response;
            if (this.uniqLocalIngID !== undefined) {
              e.ingID = this.uniqLocalIngID[0];
              e.ingPureDetails.forEach(element => {
                substanceRow = {
                  ingID: e.ingID,
                  ingName: e.ingDescription,
                  ingredientPer: e.ingQuantity,
                  subName: element.substanceName,
                  sirId: element.substanceID,
                  sirPercentageInIng: element.pureQuantityPerItem,
                  casNumber: element.casNumber,
                  einecs: element.einecsNumber,
                  errorDetails: element.substanceError,
                  inciName: element.inciNumber,
                  pureCode: element.pureCode,
                  sirQty: (e.ingQuantity * element.pureQuantityPerItem) / 100,
                  uom: '%',
                  isTemporaryIngredient: 1
                };
                this.segregatecompositionData.push(substanceRow);
              });
            }
          }, (error) => {
            this.loading = false;
          });
        } else {
          // If ingredient ID remains unchanged
          e.ingPureDetails.forEach(element => {
            substanceRow = {
              ingID: e.ingID,
              ingName: e.ingDescription,
              ingredientPer: e.ingQuantity,
              subName: element.substanceName,
              sirId: element.substanceID,
              sirPercentageInIng: element.pureQuantityPerItem,
              casNumber: element.casNumber,
              einecs: element.einecsNumber,
              errorDetails: element.substanceError,
              inciName: element.inciNumber,
              pureCode: element.pureCode,
              sirQty: (e.ingQuantity * element.pureQuantityPerItem) / 100,
              uom: '%',
              isTemporaryIngredient: 0
            };
            this.segregatecompositionData.push(substanceRow);
          });
        }
      });
      this.segregatecompositionData = this.segregatecompositionData.concat(this.tempCompositionData);
      this.calculateingQtySIRQty();
      this.importfromPlm = false;
      this.importFromPLMDetail = [];
      this.cucaltver = '';
      this.populateImportFromPlmTfcData();
    }
  }
  updateTotalSirPercentplm() {
    let totalSum = 0;
    this.importFromPLMDetail.forEach(e => {
      e.ingPureDetails.forEach(c => {
        if (c.pureQuantityPerItem !== '') {
          totalSum = totalSum + parseFloat(c.pureQuantityPerItem);
        }
      });
      e.totalSirPercent = totalSum;
      totalSum = 0;
    });
    this.submitEnableDisable();
  }
  getLastLevelTfcId() {
    if (this.selectedSubClass) {
      return this.selectedSubClass.tfcLevel4Id;
    } else if (this.selectedClass) {
      return this.selectedClass.tfcLevel3Id;
    } else if (this.selectedType) {
      return this.selectedType.tfcLevel2Id;
    } else if (this.selectedFC) {
      return this.selectedFC.tfcLevel1Id;
    } else if (this.updName) {
      return this.updName.updId;
    } else {
      return '';
    }
  }
  saveRecipeDetails() {
    if (this.recipeDescription !== '') {
      console.log('save data');
      this.loadingmappinglistMessage = 'Saving recipe data';
      this.loading = true;
      const lastLevelTfcId = this.getLastLevelTfcId();
      const dataToBeSaved = {
        RECIPEHEADER: [
          {
            RecipeID: this.recipeId,
            RecipeDescription: this.recipeDescription,
            RecipeVer: this.recipeVersion,
            RecipeComments: this.recipeComment ? this.recipeComment : '',
            RecipeType: 'NonPLM',
            UPD: this.updName ? this.updName.updName : '',
            FORMULATIONCAT: this.selectedFC ? this.selectedFC.tfcLevel1Name : '',
            FORMULATIONTYPE: this.selectedType ? this.selectedType.tfcLevel2Name : '',
            FORMULATIONCLASS: this.selectedClass ? this.selectedClass.tfcLevel3Name : '',
            FORMULATIONSUBCLASS: this.selectedSubClass ? this.selectedSubClass.tfcLevel4Name : '',
            PreparationMethod: this.selectedPrepMethod ? this.selectedPrepMethod.value : '',
            RecipeStatusID: '',
            RecipeStatusDescription: '',
            UpdId: this.updName ? this.updName.updId : '',
            LastLevelTfcId: lastLevelTfcId
          }],
        RecipeCompositionData: this.segregatecompositionData ? this.segregatecompositionData : []
      };
      console.log(dataToBeSaved);
      console.log('save data');
      const apiurl = environment.APIFAsT + '/createnonplmrecipe';
      this.apiService.postData(apiurl, dataToBeSaved).subscribe((response) => {
        this.loading = false;
        console.log(response);
        this.recipeId = response.RecipeID;
        this.recipeVersion = response.RecipeVer;
        this.showRecipeSavedDialog = true;
      }, (error) => {
        this.loading = false;
        this.matSnackBar.open(error.error.message, 'close', {
          duration: 3000,
          panelClass: ['error']
        });
      });
    } else {
      this.matSnackBar.open('Please enter the Recipe Description before clicking Save', 'close', {
        duration: 3500,
        panelClass: ['error']
      });
    }
  }
  onCloseDialog() {
    // this.routersvc.navigate(['/worklist/master-worklist']);
    // localStorage.removeItem('FormObj');
  }
  closeImportPopup() {
    this.importfromPlm = false;

  }

  allowOnlyPositiveDecimal(event: KeyboardEvent) {
    const allowedChars = /[0-9.]/;
    if (!allowedChars.test(event.key)) {
      event.preventDefault();
    }
  }

  onCancelClicked() {
    this.recipeDescription = '';
    this.recipeComment = '';
    this.clearDropdownvalues(true, true, true, true);
    this.updName = null;
    this.router.navigate(['/non-plm-recipe/manage-recipe']);
  }
  bindRecipeDetails(response: any) {
    // Header details
    if (response.recipeHeader && response.recipeHeader.length > 0) {
      this.recipeDescription = response.recipeHeader[0].recipeDescription ? response.recipeHeader[0].recipeDescription : '';
      this.recipeComment = response.recipeHeader[0].recipeComments ? response.recipeHeader[0].recipeComments : '';
      this.recipeSource = response.recipeHeader[0].recipeSource ? response.recipeHeader[0].recipeSource : '';
    } else {
      this.recipeDescription = '';
      this.recipeComment = '';
    }

    this.getGroupData();
    this.updSelected({ updId: response.recipeHeader[0].UpdId, updName: response.recipeHeader[0].upd });
    this.SelectedFormulationCategory({ tfcLevel1Name: response.recipeHeader[0].formulationCat });
    this.selectedFormulationType({ tfcLevel2Name: response.recipeHeader[0].formulationType });
    this.SelectedFormulationClass({ tfcLevel3Name: response.recipeHeader[0].formulationClass });
    this.updName = { updName: response.recipeHeader[0].upd, updId: response.recipeHeader[0].UpdId };
    this.selectedFC = { tfcLevel1Name: response.recipeHeader[0].formulationCat };
    this.selectedType = { tfcLevel2Name: response.recipeHeader[0].formulationType };
    this.selectedClass = { tfcLevel3Name: response.recipeHeader[0].formulationClass };
    this.selectedSubClass = { tfcLevel4Name: response.recipeHeader[0].formulationSubClass };
    this.selectedPrepMethod = this.prepartionMethodValues.find(
      v => v.value === response.recipeHeader[0].preparationMethod
    );

    // Grid details
    this.segregatecompositionData = response.recipeCompositionData || [];

    // // If you need to trigger any calculations or validations
    this.calculateingQtySIRQty();
    this.validateOtherDetailsforRecipe();
    this.updateCompTableWithRoundedValues();
  }
  roundIfMoreThan6Decimals(num: number): number {
    const decimalPart = num.toString().split('.')[1];
    if (decimalPart && decimalPart.length > 6) {
      return Math.round(num * 1e6) / 1e6;
    }
    return num;
  }
  updateCompTableWithRoundedValues() {
    this.segregatecompositionData.forEach(element => {
      // First round Ingredient % and SIR % in ING
      element.ingredientPer = this.roundIfMoreThan6Decimals(Number(element.ingredientPer));
      element.sirPercentageInIng = this.roundIfMoreThan6Decimals(Number(element.sirPercentageInIng));

      // calculate new SIR Qty with rounded values and also round obtained SIR Qty value
      const sirQtyCalculated = (element.ingredientPer * element.sirPercentageInIng) / 100;
      element.sirQty = this.roundIfMoreThan6Decimals(Number(sirQtyCalculated));
    });
  }
}
